(ns ductile.ui.locations
  (:require [clojure.string :as str]
            [ductile.ui.components :as ui]
            [ductile.ui.components.table :as table]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.router :as router]
            [nextjournal.clerk.render.hooks :as hooks]))

(defn comma-list [k m]
  (str/join ", " (get-in m k)))

(comment
  @(deframe/!route-get :search-params))

(defn search! [search-params]
  (deframe/route-assoc! ::search-params search-params)
  (deframe/call-route-refetch {:extra-params {:search-params search-params}}))

(defn set-search-params! [attr val]
  (search! (assoc @(deframe/!route-get ::search-params) attr val)))

(defn overview [{:keys [num-results locations]} _match]
  (let [!expanded-at (hooks/use-state {})]
    [:div
     [:div.mb-4.flex.items-center.justify-between
      [:h2.text-2xl.mx-2 (tr "Locations")]
      [ui/button
       {:variant :primary
        :href (router/path '[locations new])}
       [ui/icon :plus]
       (tr "Add location")]]
     [:div.w-full.overflow-auto.rounded.border.border-slate-300.shadow
      [table/table
       {:!expanded-at !expanded-at
        :group-headers false
        :column-order [:ductile/id :address/name :address/billing-extension :customer/debtor :address/postcode
                       :address/city :address/street :address/province-code :address/country
                       :elog/adresse-id :report/emails
                       :location/delivery-hours :location/night-delivery :location/saturday-delivery]
        :column-layout {:address/name {:width 300}
                        :report/emails {:width 400}
                        :elog/haendler-id {:width 400}
                        :location/delivery-hours {:width 200}}
        :transform-columns {[:location/types] #(->> (:location/types %) (map (comp str/capitalize name)) sort (str/join ", "))
                            [:report/emails] (partial comma-list [:report/emails])
                            [:external.bmw/location-codes] (partial comma-list [:external.bmw/location-codes])
                            [:external.kia/location-codes] (partial comma-list [:external.kia/location-codes])
                            [:external.omoda-jaecoo/location-codes] (partial comma-list [:external.omoda-jaecoo/location-codes])
                            [:elog/haendler-id] (partial comma-list [:elog/haendler-id])
                            [:location/night-delivery] #(let [v (:location/night-delivery %)]
                                                          (some-> (if (map? v) (:db/ident v) v) name))
                            [:location/saturday-delivery] #(let [v (:location/saturday-delivery %)]
                                                             (some-> (if (map? v) (:db/ident v) v) name))
                            [:ductile/id] (fn [location]
                                            [:div.flex-col
                                             [ui/link {:href (router/path '[locations :ductile/id edit] location)} (tr "Edit")]
                                             (when (ui/debug-mode?)
                                               [:pre.text-xs (pr-str (:ductile/id location))])])}
        :filters (into {} (for [k [:address/name
                                   :address/billing-extension
                                   :address/postcode
                                   :customer/debtor
                                   :address/city
                                   :address/street
                                   :elog/adresse-id
                                   :report/emails
                                   :external.bmw/location-codes
                                   :external.kia/location-codes]]
                            [k [:search {:on-change (fn [v] (set-search-params! k v))}]]))}
       locations]]]))

(comment
  locations)
